module.exports = __webpack_public_path__ + "static/media/013.03a631eb.jpg";